import { atom } from 'jotai';

export const selectedAuctionGuidForDeletionAtom = atom<string | null>(null);

export const showAuctionDeleteBlockedModalAtom = atom(false);

export const showAuctionDeletionConfirmModalAtom = atom<boolean>(false);
